export default __webpack_public_path__ + "static/media/credit-card2.c61592db.svg";